
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BCXContentArea',
  props: {
    noPadding: { type: Boolean },
  },
});
